import { MaestroAPI, maestroApiCall } from '@michelin/central-provider';
import hash from 'object-hash';
import { useQuery } from 'react-query';
import { apigatewayBaseRoute as baseURL } from 'services/restApiConst';

interface WithinSpendingLimitParams {
  fleet_id: string;
  provider_id: string;
  parts: { mspn: string; qty: number; is_pql: boolean; amount?: number }[];
  price_date?: string;
  country_code: string;
  state: string | null;
  city: string | null;
  zip_code: string | null;
  order_limit: number | null;
}

export interface WithinSpendingLimitResponse {
  within_spending_limit: boolean;
  urban_admin_allow_preapproved_txs: boolean;
  message?: string;
}

const getCanCreateOrder: MaestroAPI = { method: 'POST', endpoint: 'can-create-order', baseURL };

export function useWithinSpendingLimit(payload: WithinSpendingLimitParams | null) {
  return useQuery<WithinSpendingLimitResponse | null>(
    ['dealer_within_spending_limit', hash(payload)],
    () => {
      if (payload) return maestroApiCall(getCanCreateOrder, payload);
      return null;
    },
    {
      cacheTime: 3600,
    },
  );
}
